import store from '@/store'

export default {
  computed: {
    boNavigation () {
      return store.getters['bonavigationState/boNavigation']
    },

    idfwbonavigation1 () {
      return this.$route.params.idfwbonavigation1
    },

    idfwbonavigation2 () {
      return this.$route.params.idfwbonavigation2
    },

    routeBoNavigation () {
      const routeBoNavigation = this.pIdfwbonavigation || this.idfwbonavigation1 || undefined

      if (isNaN(routeBoNavigation)) {
        return routeBoNavigation
      }

      if (routeBoNavigation.toString().indexOf('.') > -1) {
        return parseFloat(routeBoNavigation + '.1')
      }

      return parseFloat(routeBoNavigation)
    },

    currentBoNavigation () {
      const idfwbonavigation = this.idfwbonavigation2 || this.idfwbonavigation1 || 'top'
      return (idfwbonavigation && this.boNavigation && this.boNavigation[idfwbonavigation]) || undefined
    },

    currentBoNavigationForPPOnSportsPage () {
      return (this.routeBoNavigation && this.boNavigation && this.boNavigation[this.routeBoNavigation.toString()]) || undefined
    },

    sportTypeId () {
      return this.currentBoNavigationForPPOnSportsPage && this.currentBoNavigationForPPOnSportsPage.idfosporttype
        ? this.currentBoNavigationForPPOnSportsPage.idfosporttype
        : null
    },
    isRootSportsNavigation () {
      return this.$route.name === 'sports'
    },
    isSportsNavigation () {
      return this.$route.name === 'bonavigation1' || this.$route.name === 'bonavigation2' || this.$route.name === 'bonavigation3'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/BoNavigationContext.js